import {
  Box,
  Button,
  CircularProgress,
  Collapse,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Switch,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import axios from "axios";
// import PermissionChangesSaved from "./PermissionChangesSaved";
// import ResetWarning from "./ResetWarning";
import { appUrl } from "../../../../../../utils/config";
import moment from "moment";

// const initialScreensAndFeaturesData = [
//   {
//     screen_id: 1,
//     screen_name: "GRN Receipts Dashboard",
//     screen_access: true,
//     features: [
//       {
//         feature_id: 1,
//         feature: "Export to Excel",
//         feature_access: true,
//         last_updated_date: "02-OCT-2025",
//       },
//       {
//         feature_id: 2,
//         feature: "Approve GR",
//         feature_access: true,
//       },
//       {
//         feature_id: 3,
//         feature: "View GR Details",
//         feature_access: true,
//       },
//       {
//         feature_id: 4,
//         feature: "Download GR Files",
//         feature_access: false,
//         last_updated_date: "02-OCT-2025",
//       },
//     ],
//   },
//   {
//     screen_id: 2,
//     screen_name: "Schedule Agreements",
//     screen_access: false,
//     features: [
//       {
//         feature_id: 5,
//         feature: "View Schedule",
//         feature_access: false,
//         last_updated_date: "01-OCT-2025",
//       },
//     ],
//   },
//   {
//     screen_id: 3,
//     screen_name: "Delivery Schedule Details",
//     screen_access: true,
//     features: [
//       {
//         feature_id: 6,
//         feature: "Edit Delivery Schedule",
//         feature_access: true,
//         last_updated_date: "02-OCT-2025",
//       },
//       {
//         feature_id: 7,
//         feature: "Delete Delivery Schedule",
//         feature_access: false,
//       },
//     ],
//   },
//   {
//     screen_id: 4,
//     screen_name: "FG Batch",
//     screen_access: true,
//     features: [
//       {
//         feature_id: 8,
//         feature: "View FG Batch Details",
//         feature_access: true,
//         last_updated_date: "02-OCT-2025",
//       },
//     ],
//   },
// ];

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: "#1890ff",
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#1890ff",
    },
  },
  heading: {
    fontWeight: 600,
    marginBottom: "1em",
  },
  resetText: {
    color: "#87abe4",
    fontSize: "12px",
    fontWeight: 500,
    cursor: "pointer",
    textDecoration: "underline",
    marginBottom: theme.spacing(1),
  },
  listContainer: {
    border: "1px solid #ccc",
    padding: 0,
    marginBottom: theme.spacing(2),
  },
  screen: {
    padding: theme.spacing(1),
    backgroundColor: "#f5f5f5",
  },
  feature: {
    padding: theme.spacing(1),
    borderTop: "1px solid #ccc",
  },
  content: {
    flexGrow: 1,
    // backgroundColor: "red",
    // height: "100%",
  },
  buttonContainer: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    marginTop: "auto",
    marginBottom: theme.spacing(2),
    textTransform: "none",
  },
  drawerPaper: {
    width: "30vw",
  },
}));

export default function AccessAndPermissions({
  user,
  setViewDetailsDrawer,
  handleRefresh,
}) {
  const classes = useStyles();
  const [expandedSections, setExpandedSections] = useState({});
  const [apiData, setApiData] = useState([]);
  const [screensAndFeatures, setScreensAndFeatures] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [changesSavedDrawer, setChangesSavedDrawer] = useState(false);
  const [resetDrawer, setResetDrawer] = useState(false);
  const [count, setCount] = useState({ enabled: 0, disabled: 0 });
  const [reset, setReset] = useState(false);

  useEffect(() => {
    setLoading(true);
    setError(null);
    // const url = "https://run.mocky.io/v3/99ad4213-c081-454f-acee-31d7ebe1f1d2";
    const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchScreensAndFeatures/${user.collaborator_role_id}/${user.saas_user_id}`;
    axios
      .get(url)
      .then((res) => {
        if (res.data.status) {
          setApiData(res.data.data.screensAndFeatures);
          setScreensAndFeatures(res.data.data.screensAndFeatures);
        }
      })
      .catch((err) => {
        setError(err.message);
        //console.log("Error fetching");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [reset]);
  const handleExpand = (screenId) => {
    setExpandedSections((prev) => ({
      ...prev,
      [screenId]: !prev[screenId],
    }));
  };
  const handleToggleScreen = (screenId) => {
    setScreensAndFeatures((prev) =>
      prev.map((screen) =>
        screen.screen_id === screenId
          ? {
            ...screen,
            screen_access: !screen.screen_access,
            features: screen.screen_access
              ? screen.features.map((feature) => ({
                ...feature,
                feature_access: false, // Turn off all features if screen is turned off
              }))
              : screen.features, // Leave features unchanged when turning on
          }
          : screen
      )
    );
  };
  const handleToggleFeature = (screenId, featureId) => {
    setScreensAndFeatures((prev) =>
      prev.map((screen) =>
        screen.screen_id === screenId
          ? {
            ...screen,
            features: screen.features.map((feature) =>
              feature.feature_id === featureId
                ? { ...feature, feature_access: !feature.feature_access }
                : feature
            ),
          }
          : screen
      )
    );
  };
  const calculateFeatureChanges = () => {
    let newlyEnabledCount = 0;
    let newlyDisabledCount = 0;

    screensAndFeatures.forEach((screen, screenIndex) => {
      screen.features.forEach((feature) => {
        const initialFeature = apiData[screenIndex].features.find(
          (f) => f.feature_id === feature.feature_id
        );
        if (feature.feature_access && !initialFeature.feature_access) {
          newlyEnabledCount++;
        } else if (!feature.feature_access && initialFeature.feature_access) {
          newlyDisabledCount++;
        }
      });
    });
    return { newlyEnabledCount, newlyDisabledCount };
  };

  const preparePayload = () => {
    const { newlyDisabledCount } = calculateFeatureChanges();
    return {
      saas_user_id: user.saas_user_id,
      access: newlyDisabledCount > 0 ? "Partial" : "Full",
      screenAndFeatures: screensAndFeatures
        .filter((screen) => screen.screen_access) // Only include screens with access
        .map((screen) => ({
          screen_id: screen.screen_id,
          screen_name: screen.screen_name,
          screen_access: screen.screen_access,
          features: screen.features
            .filter((feature) => feature.feature_access) // Only include features with access
            .map((feature) => ({
              feature_id: feature.feature_id,
              feature: feature.feature,
              feature_access: feature.feature_access,
            })),
        })),
    };
  };

  const handleSave = () => {
    setLoading(true);
    setError(null);

    const { newlyEnabledCount, newlyDisabledCount } = calculateFeatureChanges();
    const payload = preparePayload();
    // console.log("🚀 ~ handleSave ~ payload:", payload);

    // const url = `${appUrl}/user/updateUserMapping`;
    const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateUserMapping`;
    axios
      .post(url, payload)
      .then((res) => {
        if (res.data.status) {
          setCount({
            enabled: newlyEnabledCount,
            disabled: newlyDisabledCount,
          });
          setChangesSavedDrawer(true);
        }
      })
      .catch((err) => {
        setError(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDiscard = () => {
    setScreensAndFeatures(apiData);
  };
  const displayLoading = (
    <div style={{ textAlign: "center", marginTop: "1.5em" }}>
      <CircularProgress color="primary" thickness={7} />
    </div>
  );
  const displayError = (
    <Box
      style={{
        border: "2px solid rgb(255,0,0)",
        backgroundColor: "rgb(255,240,240)",

        textAlign: "center",
        padding: "0.8rem",
        fontSize: "0.875rem",
        marginTop: "1.5em",
      }}
    >
      {" "}
      <Typography variant="body2">
        Something went wrong. Please try again later.
      </Typography>
    </Box>
  );

  const displayNoRecordsFound = (
    <Box
      style={{
        display: "flex",
        justifyContent: "center", // Horizontally center the CircularProgress
        alignItems: "center", // Vertically center the CircularProgress
        height: "50px", // Optional: Set a height to vertically center the loader
        border: "2px solid #000",
        // backgroundColor: "#FFF0F0",
        width: "100%",
        marginTop: "1.5em",
      }}
    >
      <Typography style={{ textAlign: "center" }}>No records found</Typography>
    </Box>
  );

  const displayList = (
    <List className={classes.listContainer}>
      {screensAndFeatures?.map((screen) => (
        <React.Fragment key={screen.screen_id}>
          <ListItem
            button
            className={classes.screen}
            onClick={() => handleExpand(screen.screen_id)}
          >
            <ListItemIcon>
              {expandedSections[screen.screen_id] ? (
                <ExpandLess />
              ) : (
                <ExpandMore />
              )}
            </ListItemIcon>
            <ListItemText>
              <Typography style={{ fontSize: "14px" }}>
                {screen.screen_name}
              </Typography>
            </ListItemText>
            <Switch
              classes={{ root: classes.root }}
              checked={screen.screen_access}
              onClick={(e) => e.stopPropagation()}
              onChange={() => handleToggleScreen(screen.screen_id)}
            />
          </ListItem>
          <Collapse
            in={expandedSections[screen.screen_id]}
            timeout="auto"
            unmountOnExit
          >
            <List>
              {screen.features.map((feature) => (
                <ListItem key={feature.feature_id} className={classes.feature}>
                  <Box style={{ flex: 1 }}>
                    <ListItemText>
                      <Typography style={{ fontSize: "14px" }}>
                        {feature.feature}
                      </Typography>
                    </ListItemText>
                  </Box>
                  <Box>
                    <Switch
                      classes={{ root: classes.root }}
                      checked={feature.feature_access}
                      onChange={() =>
                        handleToggleFeature(
                          screen.screen_id,
                          feature.feature_id
                        )
                      }
                      disabled={!screen.screen_access}
                    />
                  </Box>
                  <Box style={{ flex: 1, textAlign: "right" }}>
                    {feature.last_updated_date && (
                      <Typography variant="body2" color="textSecondary">
                        <ListItemText>
                          {" "}
                          <Typography style={{ fontSize: "14px" }}>
                            {moment(feature.last_updated_date).format(
                              "DD-MMM-YYYY"
                            )}
                          </Typography>
                        </ListItemText>
                      </Typography>
                    )}
                  </Box>
                </ListItem>
              ))}
            </List>
          </Collapse>
        </React.Fragment>
      ))}
    </List>
  );
  if (loading) return displayLoading;
  if (error) return displayError;
  if (apiData.length === 0) return displayNoRecordsFound;

  return (
    <Box
      style={{ minHeight: "100%", display: "flex", flexDirection: "column" }}
    >
      <Typography className={classes.heading}>
        Access and Permissions
      </Typography>
      <Typography
        className={classes.resetText}
        onClick={() => setResetDrawer(true)}
      >
        Reset to Default
      </Typography>
      {/* <Drawer
        anchor="right"
        open={resetDrawer}
        onClose={() => setResetDrawer(false)}
        classes={{ paper: classes.drawerPaper }}
        BackdropProps={{ style: { backgroundColor: "transparent" } }} // ✅ Removes backdrop
      >
        <ResetWarning
          setResetDrawer={setResetDrawer}
          setReset={setReset}
          user={user}
          handleRefresh={handleRefresh}
          setViewDetailsDrawer={setViewDetailsDrawer}
        />
      </Drawer> */}
      <Box className={classes.content}>{displayList}</Box>
      <Box className={classes.buttonContainer}>
        <Button
          size="small"
          variant="contained"
          onClick={handleDiscard}
          style={{ textTransform: "none" }}
        >
          Discard changes
        </Button>
        <Button
          size="small"
          variant="contained"
          style={{
            textTransform: "none",
            backgroundColor: "#286acf",
            color: "#fff",
          }}
          onClick={handleSave}
        >
          Save changes
        </Button>
      </Box>
      {/* <Drawer
        anchor="right"
        open={changesSavedDrawer}
        onClose={() => setChangesSavedDrawer(false)}
        classes={{ paper: classes.drawerPaper }}
        BackdropProps={{ style: { backgroundColor: "transparent" } }}
      >
        <PermissionChangesSaved
          setChangesSavedDrawer={setChangesSavedDrawer}
          count={count}
          setReset={setReset}
          user={user}
          setViewDetailsDrawer={setViewDetailsDrawer}
          handleRefresh={handleRefresh}
        />
      </Drawer> */}
    </Box>
  );
}
